import formatHelper from "./format_helper";

export const formatAmount = (num) => {
  let formattedNumber = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
  return formatHelper.numberSeperator(formattedNumber);
};
